//App.js

import React from "react";
import {BrowserRouter,Routes,Route,Navigate} from "react-router-dom";
import ReportPage from "./pages/ReportPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import PlanPage from "./pages/PlanPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import {getToken} from "./api/reportApi";
import TermsPage from "./pages/terms/TermsPage";
import PrivacyPage from "./pages/terms/PrivacyPage";
import RefundPage from "./pages/terms/RefundPage";
import HomePage from "./pages/HomePage";
import AdminBillingProviderPage from "./pages/admin/AdminBillingProviderPage";

function ProtectedRoute({children}){
    const [authenticated,setAuthenticated]=React.useState(()=>Boolean(getToken()));
    React.useEffect(()=>{
        const handleLogout=()=>setAuthenticated(false);
        window.addEventListener("custor-auth-logout",handleLogout);
        return()=>window.removeEventListener("custor-auth-logout",handleLogout);
    },[]);
    if(!authenticated)return <Navigate to="/login" replace/>;
    return children;
}

export default function App(){
    return(
        <BrowserRouter>
            <Routes>
                <Route path="/login" element={<LoginPage/>}/>
                <Route path="/register" element={<RegisterPage/>}/>
                <Route path="/verify-email" element={<VerifyEmailPage/>}/>
                <Route path="/terms" element={<TermsPage/>}/>
                <Route path="/privacy" element={<PrivacyPage/>}/>
                <Route path="/refund" element={<RefundPage/>}/>
                <Route path="/" element={<HomePage/>}/>
                <Route path="/app" element={<ProtectedRoute><ReportPage/></ProtectedRoute>}/>
                <Route path="/app/plan" element={<ProtectedRoute><PlanPage/></ProtectedRoute>}/>
                <Route path="/report/:jobId" element={<ProtectedRoute><ReportPage/></ProtectedRoute>}/>
                <Route path="/admin/billing-provider" element={<ProtectedRoute><AdminBillingProviderPage /></ProtectedRoute>}/>
            </Routes>
        </BrowserRouter>
    );
}